import { Component, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';

declare var swal: any;

@Component({
  selector: 'app-esqueci-senha',
  templateUrl: './esqueci-senha.component.html',
  styleUrls: ['./esqueci-senha.component.scss']
})
export class EsqueciSenhaComponent implements OnInit {
  requisicaoSenha: any;
  tokenInformado: string;
  nomeUsuario: string;
  Mostrar: any;
  Url: string;

  constructor(private http: Http,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
          let token = params['token'];
          let nome = params['nome'];

          this.tokenInformado = token;
          this.nomeUsuario = nome;

          this.http.get("assets/config.json").subscribe(data => {
            this.Url = data.json().BASE_WEB_API;
          });
      });
  }

  ngOnInit() {
    this.requisicaoSenha = {
      senha: "",
      senhaRepete: ""
    }
  }

  ValidarFormulario(): boolean {
    return this.requisicaoSenha.senha && this.requisicaoSenha.senhaRepete && this.requisicaoSenha.senha == this.requisicaoSenha.senhaRepete;
  }

  RegistrarAlteracao() {
    if (!this.ValidarFormulario()) {
      swal({
        title: "Atenção!",
        type: "warning",
        text: "Dados informados não conferem!"
      });

      return;
    }

    this.Mostrar = true;

    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.Url + "/api/Login/AlterarSenhaUsuario", JSON.stringify({ novaSenha: this.requisicaoSenha.senha, token: this.tokenInformado }), options)
    .pipe(map((response: Response) => response.json()))
    .subscribe(
      data => {
        this.Mostrar = false;

        swal({
          title: "Sucesso!",
          type: "success",
          text: "Senha foi alterada com sucesso!"
        }, () => {
          this.router.navigate(['/login']);
        });
      },
      error => {
        this.Mostrar = false;

        swal({
          title: "Atenção!",
          type: "warning",
          text: "Token inválido!"
        });
      }
    );
  }
}
